import { useTranslation } from "react-i18next";
import "../i18n";
import { Container } from "frno-react";

export const LanguageSwitcher = () => {
    const { i18n } = useTranslation();
  
    const toggleLanguage = () => {
        const newLang = i18n.language === 'nn' ? 'nb' : 'nn';
        void i18n.changeLanguage(newLang);
    };
  
    return (
      <Container mt={6}>
        <a 
          href="#" 
          onClick={(e) => {
            e.preventDefault();
            toggleLanguage();
          }}
          className="underline pointer --color-text-info"
        >
          {i18n.language === 'nn' ? 'Bokmål' : 'Nynorsk'}
        </a>
      </Container>
    );
};
